import { useNavigate } from "react-router-dom";

function EventCell({ item }) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        sessionStorage.setItem("categoryScroll", window.scrollY);
        return navigate(
          `/${item.event_type}/${item.id}/${item.title.replace(/ /g, "-")}`,
          {
            state: { passedData: item },
          }
        );
      }}
      className="highlight-image-container"
    >
      <img
        src={item.main_image}
        alt={`Slide ${item.created_date}`}
        className="highlight-image"
      />
      <div className="gradient-overlay"></div>
      <div className="highlight-text-container">
        <p className="highlight-title">{item.title}</p>
        <div className="highlight-price-container">
          <span className="highlight-price">
            {Number(item.price) === 0
              ? "Contact for Pricing"
              : "₹ " + Number(item.price).toLocaleString()}
          </span>
          <span className="highlight-price">{item.duration}</span>
          {/* <span className="highlight-price">{item.event_type}</span> */}
        </div>
      </div>
    </div>
  );
}

export default EventCell;
